import {
  withScope,
  captureException,
  setTags,
  setUser,
  setContext
} from '@sentry/nextjs';
import { getCurrentUserId } from '@/actions/auth';

type Params = {
  error: Parameters<typeof captureException>[number];
  tags?: Parameters<typeof setTags>[number];
  user?: Parameters<typeof setUser>[number];
  context?: {
    key: Parameters<typeof setContext>[0];
    value: Parameters<typeof setContext>[1];
  };
};

export const sendErrorToSentry = async ({
  error,
  tags = {},
  user = {},
  context
}: Params) => {
  const userId = await getCurrentUserId();

  withScope(scope => {
    scope.setUser({ id: userId, ...user });
    scope.setTags(tags);
    if (error instanceof Error) {
      scope.setFingerprint([error.name, error.message]);
    }

    if (context) {
      scope.setContext(context.key, context.value);
    }
    captureException(error);
  });
};
